"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AwardSolid: function() {
        return AwardSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const AwardSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M10.162 1.15853C11.2436 0.320529 12.7552 0.320529 13.8368 1.15853L14.1202 1.37816C14.3039 1.52045 14.5313 1.59435 14.7636 1.58719L15.122 1.57613C16.4896 1.53392 17.7125 2.4224 18.0949 3.7361L18.1952 4.08042C18.2601 4.30347 18.4007 4.49696 18.5928 4.62765L18.8893 4.82938C20.0205 5.59909 20.4876 7.03668 20.0248 8.3243L19.9035 8.66178C19.825 8.8804 19.825 9.11957 19.9035 9.33819L20.0248 9.67567C20.4876 10.9633 20.0205 12.4009 18.8893 13.1706L18.5928 13.3723C18.4007 13.503 18.2601 13.6965 18.1952 13.9196L17.9674 14.702C17.66 15.7578 16.6772 16.4718 15.5781 16.4379L14.7636 16.4128C14.5313 16.4056 14.3039 16.4795 14.1202 16.6218L13.8368 16.8414C12.7552 17.6794 11.2436 17.6794 10.162 16.8414L9.87851 16.6218C9.69486 16.4795 9.46741 16.4056 9.2352 16.4128L8.42057 16.4379C7.32151 16.4718 6.33875 15.7578 6.03139 14.7021L5.80357 13.9196C5.73863 13.6965 5.59805 13.503 5.40598 13.3723L5.10949 13.1706C3.97827 12.4009 3.51117 10.9633 3.97393 9.67567L4.09521 9.33819C4.17378 9.11957 4.17378 8.8804 4.09521 8.66178L3.97393 8.3243C3.51117 7.03668 3.97827 5.59909 5.10949 4.82938L5.40598 4.62765C5.59805 4.49696 5.73863 4.30347 5.80357 4.08042L5.90381 3.7361C6.28628 2.4224 7.50916 1.53392 8.87676 1.57613L9.2352 1.58719C9.46741 1.59435 9.69486 1.52045 9.87851 1.37816L10.162 1.15853ZM8.99951 9C8.99951 7.34317 10.3426 6 11.9995 6C13.6564 6 14.9995 7.34317 14.9995 9C14.9995 10.6568 13.6564 12 11.9995 12C10.3426 12 8.99951 10.6568 8.99951 9Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M6.02128 21.7929L7.00226 17.1634C7.44901 17.3552 7.9414 17.4533 8.4515 17.4376L9.26613 17.4124L9.54962 17.632C10.9917 18.7494 13.0072 18.7494 14.4493 17.632L14.7328 17.4124L15.5473 17.4375C16.0575 17.4533 16.55 17.3551 16.9968 17.1633L17.9778 21.7929C18.0603 22.1821 17.9042 22.5833 17.5803 22.8143C17.2563 23.0454 16.8262 23.0624 16.4851 22.8577L11.9996 20.1664L7.51405 22.8577C7.17286 23.0624 6.74277 23.0454 6.41885 22.8143C6.09492 22.5833 5.9388 22.1821 6.02128 21.7929Z",
            fill: "currentColor"
        })
    ]
}), "AwardSolid");
const _default = AwardSolid;
